var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5938 10.9319C19.1961 10.9319 20.4959 9.63298 20.4959 8.03064C20.4959 6.42831 19.1961 5.12939 17.5938 5.12939",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9297 14.085C19.4082 14.118 19.8839 14.1858 20.3524 14.2912C21.0032 14.4186 21.786 14.6854 22.0647 15.2693C22.2425 15.6433 22.2425 16.0787 22.0647 16.4536C21.7869 17.0375 21.0032 17.3034 20.3524 17.4372",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.28889 10.9319C4.68655 10.9319 3.38672 9.63298 3.38672 8.03064C3.38672 6.42831 4.68655 5.12939 6.28889 5.12939",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95565 14.085C4.47715 14.118 4.0014 14.1858 3.53298 14.2912C2.88215 14.4186 2.09931 14.6854 1.82156 15.2693C1.64281 15.6433 1.64281 16.0787 1.82156 16.4536C2.0984 17.0375 2.88215 17.3034 3.53298 17.4372",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9386 14.7095C15.1855 14.7095 17.9593 15.2008 17.9593 17.1671C17.9593 19.1324 15.2038 19.6421 11.9386 19.6421C8.69089 19.6421 5.91797 19.1507 5.91797 17.1845C5.91797 15.2182 8.67347 14.7095 11.9386 14.7095Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9364 11.9049C9.79504 11.9049 8.07812 10.188 8.07812 8.04575C8.07812 5.90442 9.79504 4.1875 11.9364 4.1875C14.0777 4.1875 15.7946 5.90442 15.7946 8.04575C15.7946 10.188 14.0777 11.9049 11.9364 11.9049Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgo);
export default __webpack_public_path__ + "static/media/NGO.18e159c88c9c650c42701add2440e4a2.svg";
export { ForwardRef as ReactComponent };